import {
  call, put, select, takeLatest, takeEvery,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import findResult, {
  isValidFilter,
  wildcardFilter,
} from '@/utils/resultsHelper';
import MembershipService from '@/users/membership/service';
import { shareAPISaga } from '@/users/membership/helper';
import selectors from '@/selectors';
import { refreshCollections, destroyCollection } from '../../actions';
import {
  showCollectionMembers,
  showCollectionMembersError,
  shareCollectionError,
  shareCollectionSuccess,
  updateCurrentCollectionPermissions,
} from '../actions';
import { collectionLists } from '../../constants';
import collectionSharingActions, { collectionPermissions } from '../constants';

export function* fetchCollectionMembers(action) {
  const items = yield select(selectors.collections);
  const item = findResult(items, action.category, action.code);
  const members = action.assignable ? item.unassignedMembers : item.members;

  const filter = action.filter || members.filter;
  if (!isValidFilter(filter, members)) {
    return;
  }

  const { response, error } = yield call(
    callAdapter,
    MembershipService.entityMembers('collection', item.code, wildcardFilter(filter), action.assignable),
  );

  if (error) {
    yield put(showCollectionMembersError(action.category, action.code, error, action.assignable));
  } else {
    yield put(showCollectionMembers(
      action.category,
      action.code,
      response.items,
      response.paging.total,
      action.assignable,
    ));
  }
}

export function* share() {
  yield shareAPISaga(
    'collection',
    collectionPermissions,
    collectionLists,
    selectors.sharingCollection,
    selectors.collections,
    shareCollectionError,
    shareCollectionSuccess,
    refreshCollections,
    destroyCollection,
    updateCurrentCollectionPermissions,
  );
}

export default function* collectionSharingApi() {
  yield takeEvery(collectionSharingActions.FETCH_COLLECTION_MEMBERS, fetchCollectionMembers);
  yield takeLatest(collectionSharingActions.SHARE_COLLECTION, share);
}
